<template lang="pug">
.export-reports-tab
  .mb-3
  .box-header
    .note
      span 活動履歴の検索・表示と、CSV／PDFファイルのダウンロードが出来ます。
  .box-body.register-body
    .d-flex.flex-row.flex-wrap
      FormInputSelect.mr-4(
        v-model="functionType"
        key-name="機能" name="function-type"
        :options="functionOptions" :validation-rules="{ required: true }"
        :styles="{ 'width': '380px', 'max-width': '380px' }" style="width: 380px; flex-grow: 0;" required)
      FormInputSplitYearMonth(
        v-if="functionType != null && showTermStart == true"
        key-name="期間（開始）"
        :year.sync="startYear" :yearOptions="startYearOptions"
        :month.sync="startMonth" :monthOptions="startMonthOptions"
        validationDateKeyName="start-date" style="width: 240px; flex-grow: 0;")
      FormInputSplitYearMonth(
        v-if="functionType != null && showTermEnd == true"
        key-name="期間（終了）"
        :year.sync="endYear" :yearOptions="endYearOptions"
        :month.sync="endMonth" :monthOptions="endMonthOptions"
        validationDateKeyName="end-date" style="width: 240px; flex-grow: 0;")

    //- 1行目
    .d-flex.flex-row.flex-wrap
      //- 共通選択
      FormInputSelect.mr-4(v-if="functionType != null"
        v-model="residentGroupId"
        key-name="利用者グループ" name="resident-group" :options="residentGroupOptions"
        :styles="{ 'width': '380px', 'max-width': '380px' }" style="width: 380px; flex-grow: 0;")

      //- 面会予約、外出外泊届けの場合、利用者の単一選択
      FormInputSelect.mr-4(v-if="functionType != null && (functionType == 1 || functionType == 3)"
        v-model="residentId"
        key-name="利用者" name="resident" :options="residentOptions" :validation-rules="{ required: true }"
        :styles="{ 'width': '380px', 'max-width': '380px' }" style="width: 380px; flex-grow: 0;")
      //- 面会予約の場合、家族の単一選択
      FormInputSelect(v-if="functionType != null && functionType == 1 && showFamilySelectBox == true"
        v-model="residentsSortKey"
        key-name="家族ユーザー" name="family" :options="familyOptions" :validation-rules="{ required: true }"
        :styles="{ 'width': '380px', 'max-width': '380px' }" style="width: 380px; flex-grow: 0;")

      //- 文書送付の場合、利用者の複数選択
      FormInputMultiSelect(v-if="functionType != null && functionType == 2" :validation-rules="{ required: true }"
        v-model="residentIds" key-name="利用者" name="residentIds" :options="_allResidentOptions" 
        style="width: 380px; flex-grow: 0;" required)
        template(#filters)
          b-form-checkbox.mb-2(v-model="showAllResidents" :value="true" :unchecked-value="false" @click.native.stop) 削除済み利用者も表示する
          b-form-checkbox.mb-2(v-model="allChecked" :value="true" :unchecked-value="false" @change="changeAllChecked" @click.native.stop) 全て選択
          b-input-group.search-filter-input-group.mb-2(size="md" @click.native.stop)
            b-input-group-prepend
              b-input-group-text.search-filter-icon
                .search-icon
            b-form-input.search-filter-input(
              v-model="allResidentFilterWord"
              type="search"
              placeholder="利用者名で検索できます。"
            )

    //- 2行目、文書送付のみ使用
    .d-flex.flex-row.flex-wrap(v-if="functionType != null && functionType == 2")
      FormInputSelect.mr-4(v-model="categoryId"
        key-name="文書種類" name="category" :options="categoryOptions"
        :styles="{ 'width': '380px', 'max-width': '380px' }" style="width: 380px; flex-grow: 0;")
      FormInputSelect.mr-4(v-model="sendOption"
        key-name="送付時のオプション設定" name="send-option" :options="sendOptions"
        :styles="{ 'width': '380px', 'max-width': '380px' }" style="width: 380px; flex-grow: 0;")
      FormInputSelect.mr-4(v-model="existReply"
        key-name="家族の返信有無" name="exist-reply" :options="existReplyOptions"
        :styles="{ 'width': '380px', 'max-width': '380px' }" style="width: 380px; flex-grow: 0;")

    .preview-table-content
      ReservationReportPreviewTable(v-if="showReservationTable == true"
        v-model="reservationTableItems" :fields="reservationTableFields" :isLoading="isReservationTableLoading")
      SendDocumentsReportPreviewTable(v-if="showSendDocumentTable == true"
        v-model="sendDocumentTableItems" :fields="sendDocumentTableFields" :isLoading="isSendDocumentTableLoading")
      OutingReportPreviewTable(v-if="showOutingTable == true"
        v-model="outingTableItems" :fields="outingTableFields" :isLoading="isOutingTableLoading")

  .box-footer.register-footer
    ValidationAlert(v-model="showValidationAlert")
    .buttons.m-0
      button.btn.preview-btn(@click="previewReport(functionType)" type="button") 検索・表示
      button.btn.export-btn(v-if="_useFamilyService && _isOverLightPlan" @click="exportReport(functionType)" type="button") ダウンロード

  SendDocumentPdfSelectModal(
    v-model="showPdfSelectModal"
    @submit="handlePdfSelectSubmit"
  )
  RelativeLoading(:isBusy="isBusy" :message="loadingMessage")
  PageLoading(:isBusy="isLoading" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import moment, { Moment } from "moment";

import { userStore, fontsStore } from "@/store/store";
import Setting from "../../../../public/setting.json";
import CustomValidate from "@/commons/utils/CustomValidate";
import { SendDocumentsReportPdf as SendDocumentsReportPdfUtil } from "@/commons/utils/SendDocumentsReportPdf";
import S3UrlService from "@/commons/services/S3Url";
import PdfUtil from "@/commons/utils/PdfUtil";
import { errorHandle } from "@/errorHandler";

import ResidentsService, { ResidentGetModel } from "@/commons/services/Residents";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import FamiliesService, { FamilyGetModel } from "@/commons/services/Families";
import ReservationsService, { InputType, ReservationsGetModel, ReservationType } from "@/commons/services/Reservations";
import SendDocumentsService, {
  SendDocumentFamilyReceiver,
  SendDocumentFile,
  SendDocumentGetModel,
  SendDocumentGetsQuery,
  SendDocumentReplyGetModel,
  SendMessageGroupInfo,
  Type,
  Unit
} from "@/commons/services/SendDocuments";
import SendDocumentCategoriesService, { SendDocumentCategoryGetModel } from "@/commons/services/SendDocumentCategories";
import OutingsService, { InputBy, NeedsMeal, OutingGetModel, OutingType } from "@/commons/services/Outings";

import { FacilityGetModel } from "@/commons/services/Facilities";
import { PlanType } from "@/commons/services/Plans";
import { GroupType } from "@/commons/services/SendMessageGroups";
import SystemError from "@/commons/models/SystemError";
import SendSystemErrorService from "@/commons/services/SendSystemError";

import RelativeLoading from "@/pc/basics/RelativeLoading.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import FormInputSplitYearMonth from "@/pc/components/forms/FormInputSplitYearMonth.vue";
import ReservationReportPreviewTable, { ReservationReportPreviewTableField, ReservationReportPreviewTableItem } from "@/pc/containers/reports/ReservationReportPreviewTable.vue";
import SendDocumentsReportPreviewTable, {
  SendDocumentsReportPreviewTableField,
  SendDocumentsReportPreviewTableItem
} from "@/pc/containers/reports/SendDocumentsReportPreviewTable.vue";
import FormInputMultiSelect from "@/pc/containers/reports/FormInputMultiSelect.vue";
import OutingReportPreviewTable, { OutingReportPreviewTableField, OutingReportPreviewTableItem } from "@/pc/containers/reports/OutingReportPreviewTable.vue";
import SendDocumentPdfSelectModal from "@/pc/components/modals/SendDocumentPdfSelectModal.vue";

/**
 * ### 活動履歴エクスポートタブコンポーネント
 */
@Component({
  components: {
    RelativeLoading,
    PageLoading,
    ValidationAlert,
    FormInput,
    FormInputSelect,
    FormInputSplitYearMonth,
    ReservationReportPreviewTable,
    SendDocumentsReportPreviewTable,
    OutingReportPreviewTable,
    FormInputMultiSelect,
    SendDocumentPdfSelectModal
  },
  $_veeValidate: { validator: "new" }
})
export default class ExportReportTab extends Vue {
  /** 利用者サービス */
  @Inject("ResidentsService") residentsService!: ResidentsService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** 家族ユーザーサービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 面会予約サービス(複数) */
  @Inject("ReservationsService") reservationsService!: ReservationsService;
  /** 文書送付サービス */
  @Inject("SendDocumentsService") sendDocumentsService!: SendDocumentsService;
  /** 文書送付カテゴリーサービス */
  @Inject("SendDocumentCategoriesService") categoriesService!: SendDocumentCategoriesService;
  /** 外出外泊サービス */
  @Inject("OutingsService") outingsService!: OutingsService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;

  // #3782
  /** システムエラーサービス */
  @Inject("SendSystemErrorService") sendSystemErrorService!: SendSystemErrorService;

  /** 施設名 */
  @Getter("getFacility") facility!: FacilityGetModel;

  /** PDF出力形式選択モーダル表示フラグ */
  showPdfSelectModal: boolean = false;
  /** 取得した文書送付一覧 */
  rawSendDocuments: Array<SendDocumentGetModel> = [];

  /** タブローディング表示可否 */
  isBusy: boolean = false;
  /** ページ全体ローディング表示可否 */
  isLoading: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 出力対象の機能 */
  functionType: FunctionType | null = null;
  /** 出力対象の機能選択肢 */
  functionOptions: Array<{ value: number | string; label: string }> = [{ value: FunctionType.RESERVATION, label: "面会予約" }];

  /** 出力期間開始を表示するか否か */
  showTermStart: boolean = false;
  /** 出力期間開始「年」 */
  startYear: number = 0;
  /** 出力期間「年」選択肢 */
  startYearOptions: Array<{ value: number | string; label: string }> = [];
  /** 出力期間開始「月」 */
  startMonth: number | null = 0;
  /** 出力期間「年」選択肢 */
  startMonthOptions: Array<{ value: number | string; label: string }> = [];

  /** 出力期間終了を表示するか否か */
  showTermEnd: boolean = false;
  /** 出力期間終了「年」 */
  endYear: number = 0;
  /** 出力期間「年」選択肢 */
  endYearOptions: Array<{ value: number | string; label: string }> = [];
  /** 出力期間終了「月」 */
  endMonth: number | null = 0;
  /** 出力期間「年」選択肢 */
  endMonthOptions: Array<{ value: number | string; label: string }> = [];

  /** 利用者グループID */
  residentGroupId: number = 0;
  /** 利用者グループ選択肢 */
  residentGroupOptions: Array<{ value: number | string; label: string }> = [];
  /** 利用者グループMAP。key：利用者グループID、value：利用者グループ情報 */
  residentGroupMap: Map<number, ResidentGroupsGetModel> = new Map<number, ResidentGroupsGetModel>();

  /** 利用者ID */
  residentId: number = 0;
  /** セレクトボックス用項目で使用する利用者 */
  residents: Array<ResidentGetModel> = [];
  /** 利用者MAP。key：利用者ID、value：利用者情報 */
  residentMap: Map<number, ResidentGetModel> = new Map<number, ResidentGetModel>();
  /** 利用者選択肢 */
  residentOptions: Array<{ value: number | string; label: string; deleteFlag: boolean }> = [];

  /** セレクトボックス用項目で使用する利用者（削除済みを含む） */
  allResidents: Array<ResidentGetModel> = [];
  /** 利用者ID（複数選択用） */
  residentIds: number[] = [];
  /** 利用者MAP。key：利用者ID、value：利用者情報 */
  allResidentMap: Map<number, ResidentGetModel> = new Map<number, ResidentGetModel>();
  /** 利用者選択肢 */
  allResidentOptions: Array<{ value: number | string; label: string; deleteFlag: boolean; groupId: number }> = [];
  /** 利用者複数選択の「削除済み利用者も表示する」 */
  showAllResidents: boolean = false;
  /** 利用者複数選択の全て選択 */
  allChecked: boolean = false;
  /** 利用者複数選択の文字列フィルタリング */
  allResidentFilterWord: string = "";

  /** 家族を特定するための利用者ソートキー */
  residentsSortKey: string = "0";
  /** 家族選択肢表示可否 */
  showFamilySelectBox: boolean = false;
  /** 家族選択肢 */
  familyOptions: Array<{ value: number | string; label: string }> = [];
  /** セレクトボックス用項目で使用する家族 */
  families: Array<FamilyGetModel> = [];
  /** 家族MAP。key：利用者ID+家族ID、value：家族情報 */
  familyMap: Map<string, FamilyGetModel> = new Map<string, FamilyGetModel>();

  /** 文書種類カテゴリID */
  categoryId: number | null = null;
  /** 文書種類カテゴリID選択肢 */
  categoryOptions: Array<{ value: number | string; label: string }> = [];
  /** オプション */
  sendOption: SendDocumentsReportPdfType | null = null;
  /** オプション選択肢 */
  sendOptions: Array<{ value: number | string; label: string }> = [
    { value: SendDocumentsReportPdfType.ALL, label: "全ての文書" },
    { value: SendDocumentsReportPdfType.AGREEMENT, label: "同意取得の文書のみ" },
    { value: SendDocumentsReportPdfType.CONFIRM, label: "確認取得の文書のみ" },
    { value: SendDocumentsReportPdfType.NONE, label: "オプション無しの文書のみ" }
  ];
  /** 返信有無 */
  existReply: ExistReply | null = null;
  /** 返信有無選択肢 */
  existReplyOptions: Array<{ value: number | string; label: string }> = [
    { value: ExistReply.ALL, label: "全ての文書" },
    { value: ExistReply.EXIST_ONLY, label: "返信有りの文書のみ" },
    { value: ExistReply.NOTEXIST_ONLY, label: "返信無しの文書のみ" }
  ];

  /** 活動履歴面会予約プレビューテーブル、表示可否 */
  showReservationTable: boolean = false;
  /** 活動履歴面会予約プレビューテーブル、列名 */
  reservationTableFields: Array<ReservationReportPreviewTableField> = [];
  /** 活動履歴面会予約プレビューテーブル、行 */
  reservationTableItems: Array<ReservationReportPreviewTableItem> = [];
  /** 活動履歴面会予約プレビューテーブル、読込み中表示可否 */
  isReservationTableLoading: boolean = false;

  /** 活動履歴文書送付プレビューテーブル、表示可否 */
  showSendDocumentTable: boolean = false;
  /** 活動履歴文書送付プレビューテーブル、列名 */
  sendDocumentTableFields: Array<SendDocumentsReportPreviewTableField> = [];
  /** 活動履歴文書送付プレビューテーブル、行 */
  sendDocumentTableItems: Array<SendDocumentsReportPreviewTableItem> = [];
  /** 活動履歴文書送付プレビューテーブル、読込み中表示可否 */
  isSendDocumentTableLoading: boolean = false;

  /** 外出外泊届けプレビューテーブル、表示可否 */
  showOutingTable: boolean = false;
  /** 外出外泊届けプレビューテーブル、列名 */
  outingTableFields: Array<OutingReportPreviewTableField> = [];
  /** 外出外泊届けプレビューテーブル、行 */
  outingTableItems: Array<OutingReportPreviewTableItem> = [];
  /** 外出外泊届けプレビューテーブル、読込み中表示可否 */
  isOutingTableLoading: boolean = false;

  errorCapture: { stack: string; message: string; actions: string[] } = { stack: "", message: "reports::ExportReportTab component", actions: [] };

  // #3782 解析用情報をAPI経由で登録する
  errorCaptured(): boolean {
    this.sendSystemErrorService.post(this.errorCapture, userStore, this.$router, this.errorCapture.actions);
    return true;
  }

  get _useFamilyService(): boolean {
    return userStore.facility.useFamilyService;
  }

  /** ### プランがベーシック以上かを返す */
  get _isOverLightPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.LIGHT <= planType) {
      return true;
    } else {
      return false;
    }
  }

  get _allResidentOptions(): Array<{ value: number | string; label: string; groupId: number }> {
    const wordFilterdAllResidentOptions = this.allResidentOptions.filter((option) => this.filterResidentGroup(option) && this.filterSearchWords(option));

    if (this.showAllResidents) {
      return wordFilterdAllResidentOptions;
    } else {
      return wordFilterdAllResidentOptions.filter((option) => {
        return !option.deleteFlag;
      });
    }
  }

  filterResidentGroup(option: { value: number | string; label: string; deleteFlag: boolean; groupId: number }): boolean {
    console.log("this.residentGroupId:", this.residentGroupId);
    if (0 == this.residentGroupId || option.groupId == this.residentGroupId) {
      return true;
    }
    return false;
  }

  public filterSearchWords(option: { value: number | string; label: string; deleteFlag: boolean }): boolean {
    if (this.allResidentFilterWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(this.allResidentFilterWord);

    let foundResidentName: boolean = true;

    for (const word of words) {
      if (option.label.indexOf(word) == -1) {
        foundResidentName = false;
      }
    }

    return foundResidentName;
  }

  /**
   * ### 機能の値更新を監視する
   *
   * - 初期化する
   */
  @Watch("functionType")
  public async changeFunctionType(functionType: FunctionType | null): Promise<void> {
    // #3782
    this.errorCapture.actions.push("changeFunctionType");

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.initializePreviewTables();
    this.initializeTerms(functionType);
    this.initializeResidentGroupId();
    this.initializeFamilySelectBox(functionType);
    await this.initializeSendDocument(functionType);

    this.isBusy = false;

    return;
  }

  /**
   * ### 各プレビューテーブルを初期化する
   */
  public initializePreviewTables(): void {
    this.showReservationTable = false;
    this.showSendDocumentTable = false;
    this.showOutingTable = false;

    return;
  }

  /**
   * ### 期間の表示可否、入力値を初期化する
   */
  public initializeTerms(functionType: FunctionType | null): void {
    switch (functionType) {
      // 面会予約
      case FunctionType.RESERVATION: {
        this.showTermStart = true;
        this.showTermEnd = true;
        break;
      }
      // 文書送付
      case FunctionType.SEND_DOCUMENT: {
        this.showTermStart = true;
        this.showTermEnd = true;
        break;
      }
      // 外出外泊届け
      case FunctionType.OUTING: {
        this.showTermStart = true;
        this.showTermEnd = true;
        break;
      }
      default: {
        this.showTermStart = false;
        this.showTermEnd = false;
        break;
      }
    }

    return;
  }

  /**
   * ### 利用者グループIDを初期化する
   */
  public initializeResidentGroupId(): void {
    this.changeResidentGroupId(0);
    this.residentGroupId = 0;
    return;
  }

  /**
   * ### 家族の選択肢表示可否を初期化する
   */
  public initializeFamilySelectBox(functionType: FunctionType | null): void {
    switch (functionType) {
      case FunctionType.RESERVATION: {
        this.showFamilySelectBox = true;
        break;
      }
      default: {
        this.showFamilySelectBox = false;
        break;
      }
    }

    return;
  }

  /**
   * ### 文書送付の固有情報を初期化する
   */
  public async initializeSendDocument(functionType: FunctionType | null): Promise<void> {
    this.categoryId = 0;
    this.sendOption = 0;
    this.existReply = 0;

    if (functionType == FunctionType.SEND_DOCUMENT && this.categoryOptions.length == 0) {
      const categories: Array<SendDocumentCategoryGetModel> = await this.getSendDocumentCategories();
      const categoryOptions: Array<{ value: number | string; label: string }> = this.createCategoryOptions(categories);
      this.categoryOptions = categoryOptions;
    }

    return;
  }

  /**
   * ### 文書送付カテゴリーを取得する
   */
  public async getSendDocumentCategories(): Promise<Array<SendDocumentCategoryGetModel>> {
    const response: Array<SendDocumentCategoryGetModel> = await this.categoriesService.gets(userStore);
    return response;
  }

  /**
   * ### 文書送付のカテゴリーの選択肢を作成する
   */
  public createCategoryOptions(categories: Array<SendDocumentCategoryGetModel>): Array<{ value: number | string; label: string }> {
    let options: Array<{ value: number | string; label: string }> = [{ value: 0, label: "全て" }];
    for (const category of categories) {
      options.push({ value: category.id, label: category.name });
    }
    return options;
  }

  /**
   * ### 利用者グループIDの値更新を監視する
   *
   * - 利用者IDをリセットする
   * - 利用者のセレクトボックス選択項目を更新する
   */
  @Watch("residentGroupId")
  public changeResidentGroupId(groupId: number): void {
    // #3782
    this.errorCapture.actions.push("changeResidentGroupId");

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const residentOptions: Array<{ value: number; label: string; deleteFlag: boolean }> = this.createResidentOptions(this.residents, groupId);
    this.residentOptions = residentOptions;

    // 利用者IDが0の場合はWatchで呼び出すメソッドが呼び出されないので自分で呼ぶ
    if (this.residentId == 0) {
      this.changeResidentId(0);
    } else {
      this.residentId = 0;
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### 利用者IDの値更新を監視する
   *
   * - 家族選択セレクトボックスが表示可であれば以下を実施する
   *   - 家族IDをリセットする
   *   - 家族のセレクトボックス選択項目を更新する
   */
  @Watch("residentId")
  public changeResidentId(residentId: any | number): void {
    // #3782
    this.errorCapture.actions.push("changeResidentId");

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    if (this.showFamilySelectBox == true) {
      let residentIds: number[] = [];
      if (residentId != 0) {
        residentIds.push(residentId);
      } else {
        for (const resident of this.residents) {
          if (resident.groupId == this.residentGroupId || this.residentGroupId == 0) {
            residentIds.push(resident.id);
          }
        }
      }

      const familyOptions: Array<{ value: string; label: string }> = this.createFamilyOptions(this.families, residentIds);
      this.residentsSortKey = "0";
      this.familyOptions = familyOptions;
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### vue lifecycle created
   */
  public created(): void {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public async mounted(): Promise<void> {
    // #3782
    this.errorCapture.actions.push("mounted");

    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   *
   * - プランがライト以上なら出力できる機能に「外出外泊届け」を追加する
   * - プランがベーシック以上なら出力できる機能に「文書送付（家族）」を追加する
   * - セレクトボックス用の利用者グループリストを作成する
   *   - セレクトボックスの利用者グループ初期値は0(全て)とする
   * - セレクトボックス用の利用者リストを作成する
   *   - セレクトボックスの利用者初期値は0(全て)とする
   * - セレクトボックス用の家族リストを作成する
   *   - セレクトボックスの家族初期値は0(全て)とする
   * - セレクトボックス用の年月のリストを作成する
   */
  public async createView(): Promise<void> {
    // #3782
    this.errorCapture.actions.push("createView");

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const planType: PlanType = userStore.facility.planType;
    if (PlanType.BASIC <= planType) {
      this.functionOptions.push({ value: FunctionType.OUTING, label: "外出外泊届け" });
    }
    if (PlanType.BASIC <= planType) {
      this.functionOptions.push({ value: FunctionType.SEND_DOCUMENT, label: "文書送付（家族）" });
    }

    const residents: Array<ResidentGetModel> = await this.getResidents("false");
    const residentMap: Map<number, ResidentGetModel> = this.createResidentMap(residents);
    const residentOptions: Array<{ value: number; label: string; deleteFlag: boolean; groupId: number }> = this.createResidentOptions(residents, this.residentGroupId);
    this.residents = residents;
    this.residentMap = residentMap;
    this.residentId = 0;
    this.residentOptions = residentOptions;

    const allResidents: Array<ResidentGetModel> = await this.getResidents("true");
    const allResidentMap: Map<number, ResidentGetModel> = this.createResidentMap(allResidents);
    const allResidentOptions: Array<{ value: number; label: string; deleteFlag: boolean; groupId: number }> = this.createResidentOptions(allResidents, this.residentGroupId);
    this.allResidents = allResidents;
    this.allResidentMap = allResidentMap;
    this.allResidentOptions = allResidentOptions;

    const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const residentGroupMap: Map<number, ResidentGroupsGetModel> = this.createResidentGroupMap(residentGroups);
    const residentGroupOptions: Array<{ value: number; label: string }> = this.createResidentGroupOptions(residentGroups, residents);
    this.residentGroupMap = residentGroupMap;
    this.residentGroupId = 0;
    this.residentGroupOptions = residentGroupOptions;

    const families: Array<FamilyGetModel> = await this.getFamilies();
    const familyMap: Map<string, FamilyGetModel> = this.createFamilyMap(families);
    const familyOptions: Array<{ value: string; label: string }> = this.createFamilyOptions(families, [this.residentId]);
    this.familyMap = familyMap;
    this.families = families;
    this.residentsSortKey = "0";
    this.familyOptions = familyOptions;

    const date: Moment = moment();
    this.startYear = date.get("year");
    this.startMonth = date.get("month") + 1;
    this.startYearOptions = this.createYearOptions(userStore.facility.created);
    this.startMonthOptions = this.createMonthOptions();

    this.endYear = date.get("year");
    this.endMonth = date.get("month") + 1;
    this.endYearOptions = this.createYearOptions(userStore.facility.created);
    this.endMonthOptions = this.createMonthOptions();

    this.isBusy = false;

    return;
  }

  /**
   * ### 利用者取得
   */
  public async getResidents(addDeleted: "true" | "false"): Promise<Array<ResidentGetModel>> {
    let response: Array<ResidentGetModel> = [];

    try {
      response = await this.residentsService.gets(userStore, { addDeleted });
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.residentsService.getCount(userStore, { addDeleted });
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number; addDeleted: "true" | "false" } = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount,
            addDeleted
          };
          response = response.concat(await this.residentsService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 利用者MAPを作成する
   *
   * - key：利用者ID
   * - value：利用者情報
   */
  public createResidentMap(residents: Array<ResidentGetModel>): Map<number, ResidentGetModel> {
    const map: Map<number, ResidentGetModel> = new Map<number, ResidentGetModel>();
    for (const resident of residents) {
      map.set(resident.id, resident);
    }
    return map;
  }

  /**
   * ### 利用者セレクトボックス用項目を作成する
   *
   * - 渡されたグループIDを持つ利用者のみを項目にする
   * - 渡されたグループIDが0(全て)の場合は全利用者を項目にする
   * - 選択肢の表示項目名は「全て」と「利用者名（利用者部屋名）」
   */
  public createResidentOptions(residents: Array<ResidentGetModel>, groupId: number): Array<{ value: number; label: string; deleteFlag: boolean; groupId: number }> {
    const options: Array<{ value: number; label: string; deleteFlag: boolean; groupId: number }> = [];
    if (this.functionType == FunctionType.RESERVATION || this.functionType == FunctionType.OUTING) {
      options.push({
        value: 0,
        label: `全て`,
        deleteFlag: false,
        groupId: 0
      });
    }
    for (const resident of residents) {
      if (resident.groupId == groupId || groupId == 0) {
        options.push({
          value: resident.id,
          label: `${resident.name}（${resident.room}）`,
          deleteFlag: resident.deleteFlag,
          groupId: resident.groupId
        });
      }
    }
    return options;
  }

  /**
   * ### 利用者グループ取得
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者グループMAPを作成する
   *
   * - key：利用者グループID
   * - value：利用者グループ情報
   */
  public createResidentGroupMap(residentGroups: Array<ResidentGroupsGetModel>): Map<number, ResidentGroupsGetModel> {
    let map: Map<number, ResidentGroupsGetModel> = new Map<number, ResidentGroupsGetModel>();

    for (const residentGroup of residentGroups) {
      map.set(residentGroup.id, residentGroup);
    }

    return map;
  }

  /**
   * ### 利用者グループセレクトボックス用項目を作成する
   *
   * - 利用者グループに「全て」を追加する
   * - 全て以外は渡された利用者グループで項目を作成する
   *   - ユーザーの権限を見て、閲覧できない権限の利用者グループは選択肢にしない
   *   - 利用者が一人もいない利用者グループは選択肢にしない
   */
  public createResidentGroupOptions(residentGroups: Array<ResidentGroupsGetModel>, residents: Array<ResidentGetModel>): Array<{ value: number; label: string }> {
    const options: Array<{ value: number; label: string }> = [];

    options.push({
      value: 0,
      label: `全て`
    });

    const canUseResidentGroupMap: Map<number, number> = new Map<number, number>();
    for (const resident of residents) {
      canUseResidentGroupMap.set(resident.groupId, resident.groupId);
    }
    const allowedGroupsMap: Map<number, number> = new Map<number, number>();
    for (const allowedGroup of userStore.loginUser.permissions.residentGroups) {
      allowedGroupsMap.set(allowedGroup, allowedGroup);
    }
    for (const group of residentGroups) {
      if (canUseResidentGroupMap.has(group.id) && allowedGroupsMap.has(group.id)) {
        options.push({
          value: group.id,
          label: `${group.name}`
        });
      }
    }

    return options;
  }

  /**
   * ### 家族を取得する
   */
  public async getFamilies(): Promise<Array<FamilyGetModel>> {
    let response: Array<FamilyGetModel> = [];

    try {
      response = await this.familiesService.getsInFacility(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.familiesService.getCountInFacility(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.familiesService.getsInFacility(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 家族MAPを作成する
   *
   * - key：利用者ID + "-" + 家族ID
   * - value：利用者グループ情報
   */
  public createFamilyMap(families: Array<FamilyGetModel>): Map<string, FamilyGetModel> {
    let map: Map<string, FamilyGetModel> = new Map<string, FamilyGetModel>();

    for (const family of families) {
      map.set(family.residentsSortKey, family);
    }

    return map;
  }

  /**
   * ### 家族セレクトボックス用項目を作成する
   *
   * - 渡された利用者IDを持つ家族のみを項目にする
   * - 渡された利用者IDが0(全て)の場合は全家族を項目にする
   * - 選択肢の表示項目名は「全て」と「家族名」
   */
  public createFamilyOptions(families: Array<FamilyGetModel>, residentIds: number[]): Array<{ value: string; label: string }> {
    let options: Array<{ value: string; label: string }> = [];

    options.push({
      value: "0",
      label: `全て`
    });

    for (const residentId of residentIds) {
      for (const family of families) {
        if (family.id == residentId || residentId == 0) {
          options.push({
            value: family.residentsSortKey,
            label: `${family.familyName}（${family.name}・${family.familyRelation}）`
          });
        }
      }
    }

    return options;
  }

  /**
   * ### 期間の「年」選択肢を作成する
   *
   * - 渡された日付の年から現在の年までを選択肢で返す
   */
  public createYearOptions(created: number): Array<{ value: number; label: string }> {
    // #3782
    this.errorCapture.stack = `createYearOptions() created:${created}`;

    let options: Array<{ value: number; label: string }> = [];
    const startYear: number = Number(this.$dateUtil.convertNumberToString(created, "yyyy", false));
    const currentDate: Date = new Date();
    currentDate.setFullYear(currentDate.getFullYear() + 1);
    const endYear: number = Number(this.$dateUtil.convertDateToString(currentDate, "yyyy", false));
    for (let i = startYear; i <= endYear; i++) {
      options.push({ value: i, label: `${i}` });
    }
    return options;
  }

  /**
   * ### 期間の「月」選択肢を作成する
   */
  public createMonthOptions(): Array<{ value: number; label: string }> {
    let options: Array<{ value: number; label: string }> = [];
    for (let i = 1; i <= 12; i++) {
      options.push({ value: i, label: `${i}` });
    }
    return options;
  }

  /**
   * ### 活動履歴をプレビュー表示する
   *
   * - バリデーションを行い、エラーでなければプレビューを表示する
   * - プレビューは機能別にコンポーネントを動的に作成する
   */
  public async previewReport(functionType: FunctionType): Promise<void> {
    // #3782
    this.errorCapture.actions.push("previewReport");

    const validationResult: boolean = await this.$validator.validateAll();
    const validationReservation: boolean = this.validateReservation();
    const validationSendDocument: boolean = this.validateSendDocument();
    const validationOuting: boolean = this.validateOuting();
    if (validationResult == false || validationReservation == false || validationSendDocument == false || validationOuting == false) {
      this.showValidationAlert = true;
      return;
    } else {
      this.showValidationAlert = false;
    }

    switch (functionType) {
      // 面会予約
      case FunctionType.RESERVATION: {
        this.showReservationTable = true;
        this.isReservationTableLoading = true;

        const reservationReportPreviewTableFields: Array<ReservationReportPreviewTableField> = this.createReservationReportPreviewTableField();
        this.reservationTableFields = reservationReportPreviewTableFields;

        // #3782
        this.errorCapture.stack = `previewReport() FunctionType.RESERVATION startYear:${this.startYear}, startMonth:${this.startMonth}`;

        // 面会予約を期間指定で取得するために開始日、終了日を作成する
        const startDate: Moment = moment(`${this.startYear}-${this.startMonth}`, "YYYY-MM");
        const start: number = this.$dateUtil.convertDateToNumber(startDate.toDate(), "yyyymmddhhMMss000");
        const endDate: Moment = moment(`${this.endYear}-${this.endMonth}`, "YYYY-MM");
        endDate.endOf("month");
        const end: number = this.$dateUtil.convertDateToNumber(endDate.toDate(), "yyyymmdd235959000");

        const reservations: Array<ReservationsGetModel> = await this.getReservations(start, end);
        const reservationReportPreviewTableItems: Array<ReservationReportPreviewTableItem> = this.createReservationReportPreviewTableItem(reservations, this.residentGroupMap);
        this.reservationTableItems = reservationReportPreviewTableItems;

        this.isReservationTableLoading = false;

        break;
      }
      // 文書送付
      case FunctionType.SEND_DOCUMENT: {
        this.showSendDocumentTable = true;
        this.isSendDocumentTableLoading = true;

        const sendDocumentReportPreviewTableFields: Array<SendDocumentsReportPreviewTableField> = this.createSendDocumentReportPreviewTableField();
        this.sendDocumentTableFields = sendDocumentReportPreviewTableFields;

        // #3782
        this.errorCapture.stack = `previewReport() FunctionType.SEND_DOCUMENT startYear:${this.startYear}, startMonth:${this.startMonth}`;

        // 文書送付を期間指定で取得するために開始日、終了日を作成する
        const startDate: Moment = moment(`${this.startYear}-${this.startMonth}`, "YYYY-MM");
        const start: number = this.$dateUtil.convertDateToNumber(startDate.toDate(), "yyyymmddhhMMss000");
        const endDate: Moment = moment(`${this.endYear}-${this.endMonth}`, "YYYY-MM");
        endDate.endOf("month");
        const end: number = this.$dateUtil.convertDateToNumber(endDate.toDate(), "yyyymmdd235959000");

        // 選択された利用者をMAP化する
        const residentIdMap: Map<number, number> = new Map();
        for (const residentId of this.residentIds) {
          residentIdMap.set(residentId, residentId);
        }

        // 文書送付を期間指定で取得する
        const sendDocuments: Array<SendDocumentGetModel> = await this.getSendDocuments(start, end);
        console.debug("sendDocuments result", sendDocuments);

        const sendDocumentReportPreviewTableItems: Array<SendDocumentsReportPreviewTableItem> = await this.createSendDocumentReportPreviewTableItems(sendDocuments, residentIdMap);
        const sorted: Array<SendDocumentsReportPreviewTableItem> = this.descSortBySendDatetime(sendDocumentReportPreviewTableItems);
        this.sendDocumentTableItems = sorted;

        this.isSendDocumentTableLoading = false;

        break;
      }
      // 外出外泊届け
      case FunctionType.OUTING: {
        this.showOutingTable = true;
        this.isOutingTableLoading = true;

        const outingReportPreviewTableFields: Array<OutingReportPreviewTableField> = this.createOutingReportPreviewTableField();
        this.outingTableFields = outingReportPreviewTableFields;

        // #3782
        this.errorCapture.stack = `previewReport() FunctionType.OUTING startYear:${this.startYear}, startMonth:${this.startMonth}`;

        // 面会予約を期間指定で取得するために開始日、終了日を作成する
        const startDate: Moment = moment(`${this.startYear}-${this.startMonth}`, "YYYY-MM");
        const start: number = this.$dateUtil.convertDateToNumber(startDate.toDate(), "yyyymmddhhMMss000");
        const endDate: Moment = moment(`${this.endYear}-${this.endMonth}`, "YYYY-MM");
        endDate.endOf("month");
        const end: number = this.$dateUtil.convertDateToNumber(endDate.toDate(), "yyyymmdd235959000");

        const outings: Array<OutingGetModel> = await this.getOutings(start, end);
        const outingReportPreviewTableItems: Array<OutingReportPreviewTableItem> = this.createOutingReportPreviewTableItem(outings, this.residentGroupMap);
        this.outingTableItems = outingReportPreviewTableItems;

        this.isOutingTableLoading = false;

        break;
      }
      default: {
        break;
      }
    }

    return;
  }

  /**
   * ### 面会予約のバリデーション
   */
  public validateReservation(): boolean {
    if (this.functionType != FunctionType.RESERVATION) {
      return true;
    }

    // #3782
    this.errorCapture.stack = `validateReservation() startYear:${this.startYear}, startMonth:${this.startMonth}`;

    const startDate: Moment = moment(`${this.startYear}-${this.startMonth}`, "YYYY-MM");
    const start: number = this.$dateUtil.convertDateToNumber(startDate.toDate(), "yyyymmddhhMMss000");
    const endDate: Moment = moment(`${this.endYear}-${this.endMonth}`, "YYYY-MM");
    endDate.endOf("month");
    const end: number = this.$dateUtil.convertDateToNumber(endDate.toDate(), "yyyymmdd235959000");

    this.$validator.errors.remove("start-date-year");

    if (end < start) {
      this.$validator.errors.add({ field: "start-date-year", msg: "期間（開始）が期間（終了）より未来です" });
      return false;
    }

    return true;
  }

  /**
   * ### 文書送付履歴のバリデーション
   *
   * - 機能が文書送付でなければチェックしない
   * - 文書送付の場合は利用者に「全て」がないのでresidentId=0の場合はエラーとする
   */
  public validateSendDocument(): boolean {
    if (this.functionType != FunctionType.SEND_DOCUMENT) {
      return true;
    }

    // #3782
    this.errorCapture.stack = `validateSendDocument() startYear:${this.startYear}, startMonth:${this.startMonth}`;

    const startDate: Moment = moment(`${this.startYear}-${this.startMonth}`, "YYYY-MM");
    const start: number = this.$dateUtil.convertDateToNumber(startDate.toDate(), "yyyymmddhhMMss000");
    const endDate: Moment = moment(`${this.endYear}-${this.endMonth}`, "YYYY-MM");
    endDate.endOf("month");
    const end: number = this.$dateUtil.convertDateToNumber(endDate.toDate(), "yyyymmdd235959000");

    this.$validator.errors.remove("start-date-year");
    this.$validator.errors.remove("residentIds");

    if (end < start) {
      this.$validator.errors.add({ field: "start-date-year", msg: "期間（開始）が期間（終了）より未来です" });
      return false;
    }

    if (this.residentIds.length < 1) {
      this.$validator.errors.add({ field: "residentIds", msg: "利用者は必須項目です" });
      return false;
    }

    return true;
  }

  /**
   * ### 文書送付履歴のバリデーション
   */
  public validateOuting(): boolean {
    if (this.functionType != FunctionType.OUTING) {
      return true;
    }

    // #3782
    this.errorCapture.stack = `validateOuting() startYear:${this.startYear}, startMonth:${this.startMonth}`;

    const startDate: Moment = moment(`${this.startYear}-${this.startMonth}`, "YYYY-MM");
    const start: number = this.$dateUtil.convertDateToNumber(startDate.toDate(), "yyyymmddhhMMss000");
    const endDate: Moment = moment(`${this.endYear}-${this.endMonth}`, "YYYY-MM");
    endDate.endOf("month");
    const end: number = this.$dateUtil.convertDateToNumber(endDate.toDate(), "yyyymmdd235959000");

    this.$validator.errors.remove("start-date-year");

    if (end < start) {
      this.$validator.errors.add({ field: "start-date-year", msg: "期間（開始）が期間（終了）より未来です" });
      return false;
    }

    return true;
  }

  /**
   * ### 面会予約の列名を作成する
   */
  public createReservationReportPreviewTableField(): Array<ReservationReportPreviewTableField> {
    const fields: Array<ReservationReportPreviewTableField> = [];

    fields.push({ key: "type", label: "種別", sortable: false, sortDirection: "desc", class: "text-center type" });
    fields.push({ key: "inputType", label: "入力", sortable: false, sortDirection: "desc", class: "text-center input-type" });
    fields.push({ key: "status", label: "状態", sortable: false, sortDirection: "desc", class: "text-center status" });
    fields.push({ key: "datetime", label: "面会日時", sortable: false, sortDirection: "desc", class: "text-center date" });
    fields.push({ key: "location", label: "面会場所", sortable: false, sortDirection: "desc", class: "locations" });
    fields.push({ key: "residentGroupName", label: "利用者グループ", sortable: false, sortDirection: "desc", class: "resident-group-name" });
    fields.push({ key: "resident", label: "利用者名（部屋名）", sortable: false, sortDirection: "desc", class: "resident" });
    fields.push({ key: "family", label: "面会者名（続柄）", sortable: false, sortDirection: "desc", class: "family" });
    fields.push({ key: "text", label: "家族からの連絡事項", sortable: false, sortDirection: "desc", class: "text" });

    return fields;
  }

  /**
   * ### 面会予約を取得する
   *
   * - 期間を指定して面会予約を取得する
   */
  public async getReservations(start: number, end: number): Promise<Array<ReservationsGetModel>> {
    const params: any = {
      start: start,
      end: end,
      sortKey: "datetime",
      order: "asc"
    };
    const response: Array<ReservationsGetModel> = await this.reservationsService.gets(userStore, params);
    return response;
  }

  /**
   * ### 活動履歴(面会予約)のテーブル行情報を作成する
   *
   * - 入力している利用者グループでフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は面会予約情報の利用者グループIDが一致するもののみ行情報の対象とする
   * - 入力している利用者でフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は面会予約情報の利用者IDが一致するもののみ行情報の対象とする
   * - 入力している家族でフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は面会予約情報の家族IDが一致するもののみ行情報の対象とする
   * - フィルタリング後に行情報の対象となるものは行情報を作成する
   *   - 利用者グループが削除されている場合は利用者グループ名に「不明」を格納する
   */
  public createReservationReportPreviewTableItem(
    reservations: Array<ReservationsGetModel>,
    residentGroupMap: Map<number, ResidentGroupsGetModel>
  ): Array<ReservationReportPreviewTableItem> {
    const items: Array<ReservationReportPreviewTableItem> = [];

    for (const reservation of reservations) {
      // 利用者グループによるフィルタリング
      if (this.residentGroupId != 0 && this.residentGroupId != reservation.groupId) {
        continue;
      }
      // 利用者によるフィルタリング
      if (this.residentId != 0 && this.residentId != reservation.residentId) {
        continue;
      }
      // 家族によるフィルタリング
      if (this.residentsSortKey != "0" && this.residentsSortKey != `${reservation.residentId}-${reservation.familyId}`) {
        continue;
      }

      // #3782
      this.errorCapture.stack = `createReservationReportPreviewTableItem() reservations:${JSON.stringify(reservations)}, reservation:${JSON.stringify(reservation)}, datetime:${
        reservation.datetime
      }`;

      const residentGroup: ResidentGroupsGetModel | undefined = residentGroupMap.get(reservation.groupId);
      const residentGroupName: string = residentGroup ? residentGroup.name : "不明";

      items.push({
        type: reservation.type,
        inputType: reservation.inputType,
        status: reservation.consented ? reservation.consented : false,
        datetime: Number(reservation.datetime),
        location: reservation.location ? reservation.location : "",
        residentGroupName: residentGroupName,
        resident: {
          id: reservation.residentId,
          name: reservation.residentName,
          room: reservation.residentRoom
        },
        family: {
          name: reservation.familyName,
          relation: reservation.familyRelation,
          id: reservation.familyId
        },
        text: reservation.text ? reservation.text : ""
      });
    }

    return items;
  }

  /**
   * ### 文書送付の列名を作成する
   */
  public createSendDocumentReportPreviewTableField(): Array<SendDocumentsReportPreviewTableField> {
    let fields: Array<SendDocumentsReportPreviewTableField> = [];

    fields.push({ key: "sendDatetime", label: "送付日時", sortable: false, sortDirection: "desc", class: "send-datetime" });
    fields.push({ key: "title", label: "文書タイトル", sortable: false, sortDirection: "desc", class: "title" });
    fields.push({ key: "residentGroup", label: "利用者グループ", sortable: false, sortDirection: "desc", class: "resident-group" });
    fields.push({ key: "resident", label: "利用者", sortable: false, sortDirection: "desc", class: "resident" });
    fields.push({ key: "family", label: "家族", sortable: false, sortDirection: "desc", class: "family" });
    fields.push({ key: "option", label: "オプション", sortable: false, sortDirection: "desc", class: "option" });
    fields.push({ key: "status", label: "返信状態", sortable: false, sortDirection: "desc", class: "status" });
    fields.push({ key: "replyDatetime", label: "同意／確認の返信日時", sortable: false, sortDirection: "desc", class: "reply-datetime" });
    fields.push({ key: "message", label: "返信時の連絡事項", sortable: false, sortDirection: "desc", class: "message" });

    return fields;
  }

  /**
   * ### 期間指定で文書送付を取得する
   */
  public async getSendDocuments(start: number, end: number): Promise<Array<SendDocumentGetModel>> {
    let queryParams: SendDocumentGetsQuery = { start: String(start), end: String(end), onlyParent: true };
    const response: Array<SendDocumentGetModel> = await this.sendDocumentsService.gets(userStore, queryParams);
    // 期間指定で取得した際に一時保存（未送信）も返却されるのでここでフィルタリングする
    return response.concat().filter((sendDocument) => {
      if (sendDocument.isSended) {
        return true;
      } else {
        return false;
      }
    });
  }

  /**
   * ### 活動履歴(文書送付)のテーブル行情報を作成する
   *
   * - 以下の場合はテーブル行情報から除外する
   *   - 宛先種別が施設関係者
   *   - 宛先種別が宛先グループかつ、種別が施設関係者
   *   - 入力されたカテゴリと文書送付のカテゴリが異なる
   *   - 入力されたオプションが同意取得のみで、文書送付のオプションが同意取得ではない
   *   - 入力されたオプションが確認取得のみで、文書送付のオプションが確認取得ではない
   *   - 入力されたオプションが無しのみで、文書送付のオプションが同意取得または確認取得
   *   - 選択された利用者に送られていない文書送付情報
   * - テーブル行情報を作成する
   *   - 家族からの返信を取得する
   *   - 返信があった場合かつ、返信有無が全て、返信有無が有りのみの場合はテーブル行情報にする
   *   - 返信がなかった場合かつ、返信有無が全て、返信有無が無しのみの場合はテーブル行情報にする
   */
  public async createSendDocumentReportPreviewTableItems(
    sendDocuments: Array<SendDocumentGetModel>,
    residentIdMap: Map<number, number>
  ): Promise<Array<SendDocumentsReportPreviewTableItem>> {
    const items: Array<SendDocumentsReportPreviewTableItem> = [];
    for (const sendDocument of sendDocuments) {
      if (sendDocument.type == Type.SELECTED_OTHER_USER) {
        continue;
      }

      let isOtherUser: boolean = false;
      if (sendDocument.type == Type.SEND_MESSAGE_GROUP) {
        for (const info of sendDocument.sendMessageGroupInfos as Array<SendMessageGroupInfo>) {
          if (info.type == GroupType.OTHER_USER) {
            isOtherUser = true;
            continue;
          }
        }
      }
      if (isOtherUser == true) {
        continue;
      }

      if (this.categoryId != 0 && this.categoryId != sendDocument.categoryId) {
        continue;
      }

      if (this.sendOption != SendDocumentsReportPdfType.ALL) {
        if (this.sendOption == SendDocumentsReportPdfType.AGREEMENT && sendDocument.needAgreement != true) {
          continue;
        }
        if (this.sendOption == SendDocumentsReportPdfType.CONFIRM && sendDocument.needConfirm != true) {
          continue;
        }
        if (this.sendOption == SendDocumentsReportPdfType.NONE && (sendDocument.needAgreement == true || sendDocument.needConfirm == true)) {
          continue;
        }
      }

      // receiversの中に利用者IDは同じだが、家族IDが異なる返信が存在する場合、同じ利用者IDに対して複数回返信取得してしまうので対応する #4202
      const receiverResidentIdMap: Map<number, number> = new Map();
      for (const receiver of sendDocument.receivers as Array<SendDocumentFamilyReceiver>) {
        console.debug("this.residentId:", this.residentId, "receiver.id:", receiver.id);
        if (!residentIdMap.has(receiver.id)) {
          continue;
        }
        if (receiverResidentIdMap.has(receiver.id)) {
          continue;
        } else {
          receiverResidentIdMap.set(receiver.id, receiver.id);
        }

        const sendDocumentReplies: Array<SendDocumentReplyGetModel> = await this.getSendDocumentRepliesInResident(sendDocument.mainId, receiver.id);
        console.debug("sendDocumentReplies result", sendDocumentReplies);

        let existReply: boolean = false;
        for (const reply of sendDocumentReplies) {
          if (residentIdMap.has(receiver.id)) {
            if (this.existReply == ExistReply.ALL || this.existReply == ExistReply.EXIST_ONLY) {
              items.push(this.createExistReplySendDocumentPreviewTableItem(sendDocument, reply));
            }

            existReply = true;
            continue;
          }
        }

        if (existReply == false && (this.existReply == ExistReply.ALL || this.existReply == ExistReply.NOTEXIST_ONLY)) {
          items.push(this.createNotExistReplySendDocumentPreviewTableItem(sendDocument, receiver));
        }
      }
    }

    return items;
  }

  /**
   * ### 日付の降順にソートする
   */
  public descSortBySendDatetime(items: Array<SendDocumentsReportPreviewTableItem>): Array<SendDocumentsReportPreviewTableItem> {
    return items.concat().sort((a: SendDocumentsReportPreviewTableItem, b: SendDocumentsReportPreviewTableItem) => {
      if (a.sendDatetime < b.sendDatetime) {
        return 1;
      }
      if (a.sendDatetime > b.sendDatetime) {
        return -1;
      }
      return 0;
    });
  }

  /**
   * ### 文書送付の返信を取得する
   */
  public async getSendDocumentRepliesInResident(sendDocumentId: number, residentId: number): Promise<Array<SendDocumentReplyGetModel>> {
    const response: Array<SendDocumentReplyGetModel> = await this.sendDocumentsService.getRepliesInResident(userStore, sendDocumentId, residentId);
    return response;
  }

  /**
   * ### 家族からの返信がある場合の活動履歴(文書送付)のテーブル行情報を作成する
   */
  public createExistReplySendDocumentPreviewTableItem(sendDocument: SendDocumentGetModel, reply: SendDocumentReplyGetModel): SendDocumentsReportPreviewTableItem {
    return {
      ...reply,
      sendDatetime: sendDocument.sendDatetime as number,
      title: sendDocument.title,
      needConfirm: sendDocument.needConfirm,
      needAgreement: sendDocument.needAgreement
    };
  }

  /**
   * ### 家族からの返信が無い場合の活動履歴(文書送付)のテーブル行情報を作成する
   */
  public createNotExistReplySendDocumentPreviewTableItem(sendDocument: SendDocumentGetModel, receiver: SendDocumentFamilyReceiver): SendDocumentsReportPreviewTableItem {
    let insuredNumber: string | null = null;
    let careInsuranceInsuredNumber: string | null = null;
    if (receiver.insuredNumberKey) {
      const insuredNumbers = receiver.insuredNumberKey.split("_");
      insuredNumber = insuredNumbers[0];
      careInsuranceInsuredNumber = insuredNumbers[1];
    }

    return {
      facilityId: sendDocument.facilityId,
      sendDocumentsRepliesSortKey: "",
      parentSendDocumentsMainId: sendDocument.mainId,
      sortKeyPartOne: 0,
      sortKeyPartTwo: 0,
      senderType: 1,
      datetime: null,
      message: "－",
      sourceDatetime: sendDocument.sendDatetime as number,
      residentInfo: {
        id: receiver.id,
        groupId: receiver.groupId,
        groupName: receiver.groupName,
        name: receiver.name,
        roomId: receiver.roomId,
        room: receiver.room,
        senderType: receiver.senderType,
        familyName: receiver.familyName,
        familyTel: receiver.familyTel,
        familyRelation: receiver.familyRelation,
        familyPosition: receiver.familyPosition ? receiver.familyPosition : "",
        familyLineId: receiver.familyLineId ? receiver.familyLineId : null,
        familyMailaddress: receiver.familyMailaddress ? receiver.familyMailaddress : null,
        insuredNumber: insuredNumber,
        careInsuranceInsuredNumber: careInsuranceInsuredNumber
      },
      otherUserGroupInfo: null,
      deleteFlag: false,
      updated: 0,
      created: 0,
      sendDatetime: sendDocument.sendDatetime as number,
      title: sendDocument.title,
      needConfirm: sendDocument.needConfirm,
      needAgreement: sendDocument.needAgreement
    };
  }

  /**
   * ### 文書送付テーブルの行情報を作成する
   */
  public async createSendDocumentReportPreviewTableItem(
    sendDocument: SendDocumentGetModel,
    receiver: SendDocumentFamilyReceiver
  ): Promise<Array<SendDocumentsReportPreviewTableItem>> {
    let items: Array<SendDocumentsReportPreviewTableItem> = [];
    const sendDocumentReplies: Array<any> = await this.getSendDocumentRepliesInResident(sendDocument.mainId, receiver.id);
    for (const reply of sendDocumentReplies) {
      items.push({
        ...reply,
        sendDatetime: sendDocument.sendDatetime,
        title: sendDocument.title,
        needConfirm: sendDocument.needConfirm,
        needAgreement: sendDocument.needAgreement
      });
    }

    return items;
  }

  /**
   * ### 外出外泊届けの列名を作成する
   */
  public createOutingReportPreviewTableField(): Array<OutingReportPreviewTableField> {
    const fields: Array<OutingReportPreviewTableField> = [];

    fields.push({ key: "type", label: "種別", sortable: false, sortDirection: "desc", class: "text-center type" });
    fields.push({ key: "inputType", label: "入力", sortable: false, sortDirection: "desc", class: "text-center input-type" });
    fields.push({ key: "status", label: "状態", sortable: false, sortDirection: "desc", class: "text-center status" });
    fields.push({ key: "datetime", label: "日時", sortable: false, sortDirection: "desc", class: "text-center datetime" });
    fields.push({ key: "residentGroupName", label: "利用者グループ", sortable: false, sortDirection: "desc", class: "resident-group-name" });
    fields.push({ key: "resident", label: "利用者名（部屋名）", sortable: false, sortDirection: "desc", class: "resident" });
    fields.push({ key: "applicantFamily", label: "申請者（続柄）", sortable: false, sortDirection: "desc", class: "applicant-family" });
    fields.push({ key: "applicantPickup", label: "お迎えに来る方（続柄）", sortable: false, sortDirection: "desc", class: "applicant-pickup" });
    fields.push({ key: "location", label: "主な外出場所", sortable: false, sortDirection: "desc", class: "location" });
    fields.push({ key: "selectedVehicle", label: "外出手段", sortable: false, sortDirection: "desc", class: "selected-vehicle" });
    fields.push({ key: "startDateNeedsMeal", label: "施設での食事（開始日）", sortable: false, sortDirection: "desc", class: "start-date-needs-meal" });
    fields.push({ key: "endDateNeedsMeal", label: "施設での食事（終了日）", sortable: false, sortDirection: "desc", class: "end-date-needs-meal" });

    return fields;
  }

  /**
   * ### 外出外泊届けを取得する
   *
   * - 期間を指定して外出外泊届けを取得する
   * - 削除したものも取得されるのでフィルタリングして削除されていないものだけ返す
   */
  public async getOutings(start: number, end: number): Promise<Array<OutingGetModel>> {
    const params: any = {
      start: start,
      end: end
    };
    const response: Array<OutingGetModel> = await this.outingsService.gets(userStore, params);
    return response.filter((outing) => {
      return outing.deleteFlag ? false : true;
    });
  }

  /**
   * ### 活動履歴(外出外泊届け)のテーブル行情報を作成する
   *
   * - 入力している利用者グループでフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は面会予約情報の利用者グループIDが一致するもののみ行情報の対象とする
   * - 入力している利用者でフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は外出外泊届け情報の利用者IDが一致するもののみ行情報の対象とする
   * - フィルタリング後に行情報の対象となるものは行情報を作成する
   *   - 利用者グループが削除されている場合は利用者グループ名に「不明」を格納する
   */
  public createOutingReportPreviewTableItem(outings: Array<OutingGetModel>, residentGroupMap: Map<number, ResidentGroupsGetModel>): Array<OutingReportPreviewTableItem> {
    const items: Array<OutingReportPreviewTableItem> = [];

    for (const outing of outings) {
      // 利用者グループによるフィルタリング
      if (this.residentGroupId != 0 && this.residentGroupId != outing.targetResidentInfo.groupId) {
        continue;
      }
      // 利用者によるフィルタリング
      const splitedResidentsSortKey: string[] = outing.residentsSortKey.split("_");
      if (this.residentId != 0 && this.residentId != Number(splitedResidentsSortKey[0])) {
        continue;
      }

      // #3782
      this.errorCapture.stack = `createOutingReportPreviewTableItem() outings:${JSON.stringify(outings)}, outing:${JSON.stringify(outing)}, startDatetime:${
        outing.startDatetime
      }, endDatetime:${outing.endDatetime}`;

      const residentGroup: ResidentGroupsGetModel | undefined = residentGroupMap.get(outing.targetResidentInfo.groupId);
      const residentGroupName: string = residentGroup ? residentGroup.name : "不明";

      items.push({
        type: outing.type,
        inputBy: outing.inputBy,
        startDatetime: outing.startDatetime,
        endDatetime: outing.endDatetime,
        residentGroupName,
        targetResidentInfo: outing.targetResidentInfo,
        applicantFamilyInfo: outing.applicantFamilyInfo,
        applicantPickup: outing.applicantPickup,
        pickupPerson: outing.pickupPerson,
        location: outing.location,
        selectedVehicle: outing.selectedVehicle ? outing.selectedVehicle : "",
        startDateNeedsMeal: this.createNeedsMeal(outing.startDateNeedsMeal),
        endDateNeedsMeal: outing.endDateNeedsMeal ? this.createNeedsMeal(outing.endDateNeedsMeal) : ""
      });
    }

    return items;
  }

  /**
   * ### 必要な食事のみを文字列で返す
   */
  createNeedsMeal(needsMeal: NeedsMeal): string {
    const needsMeals: string[] = [];
    if (needsMeal.breakfast) {
      needsMeals.push("朝食");
    }
    if (needsMeal.lunch) {
      needsMeals.push("昼食");
    }
    if (needsMeal.snack) {
      needsMeals.push("おやつ");
    }
    if (needsMeal.dinner) {
      needsMeals.push("夕食");
    }
    return needsMeals.join("、");
  }

  /**
   * ### 活動履歴を出力する
   *
   * - バリデーションを行い、エラーでなければプレビューを表示する
   * - 活動履歴は機能別にCSVファイルを作成する
   */
  public async exportReport(functionType: FunctionType): Promise<void> {
    // #3782
    this.errorCapture.actions.push("exportReport");

    const validationResult: boolean = await this.$validator.validateAll();
    const validationSendDocument: boolean = this.validateSendDocument();
    if (validationResult == false || validationSendDocument == false) {
      this.showValidationAlert = true;
      return;
    } else {
      this.showValidationAlert = false;
    }

    switch (functionType) {
      // 面会予約
      case FunctionType.RESERVATION: {
        this.isLoading = true;

        // #3782
        this.errorCapture.stack = `exportReport() FunctionType.RESERVATION startYear:${this.startYear}, startMonth:${this.startMonth}`;

        // 面会予約を期間指定で取得するために開始日、終了日を作成する
        const startDate: Moment = moment(`${this.startYear}-${this.startMonth}`, "YYYY-MM");
        const start: number = this.$dateUtil.convertDateToNumber(startDate.toDate(), "yyyymmddhhMMss000");
        const endDate: Moment = moment(`${this.endYear}-${this.endMonth}`, "YYYY-MM");
        endDate.endOf("month");
        const end: number = this.$dateUtil.convertDateToNumber(endDate.toDate(), "yyyymmdd235959000");

        const reservations: Array<ReservationsGetModel> = await this.getReservations(start, end);
        const csv: string = this.createReservationCsv(reservations, this.residentGroupMap);
        const fileName: string = this.createCsvFileName(functionType, this.residentGroupMap, this.residentMap, this.familyMap);
        this.downloadCsv(csv, fileName);

        this.isLoading = false;

        break;
      }
      // 文書送付
      case FunctionType.SEND_DOCUMENT: {
        this.isLoading = true;
        this.loadingMessage = "読込み中...";

        // #3782
        this.errorCapture.stack = `exportReport() FunctionType.SEND_DOCUMENT startYear:${this.startYear}, startMonth:${this.startMonth}`;

        // 文書送付を期間指定で取得するために開始日、終了日を作成する
        const startDate: Moment = moment(`${this.startYear}-${this.startMonth}`, "YYYY-MM");
        const start: number = this.$dateUtil.convertDateToNumber(startDate.toDate(), "yyyymmddhhMMss000");
        const endDate: Moment = moment(`${this.endYear}-${this.endMonth}`, "YYYY-MM");
        endDate.endOf("month");
        const end: number = this.$dateUtil.convertDateToNumber(endDate.toDate(), "yyyymmdd235959000");

        // 選択された利用者をMAP化する
        const residentIdMap: Map<number, number> = new Map();
        for (const residentId of this.residentIds) {
          residentIdMap.set(residentId, residentId);
        }

        // 文書送付を期間指定で取得する
        const sendDocuments: Array<SendDocumentGetModel> = await this.getSendDocuments(start, end);
        this.rawSendDocuments = sendDocuments;

        const sendDocumentReportPreviewTableItems: Array<SendDocumentsReportPreviewTableItem> = await this.createSendDocumentReportPreviewTableItems(sendDocuments, residentIdMap);
        this.sendDocumentTableItems = sendDocumentReportPreviewTableItems;

        this.isLoading = false;
        this.showPdfSelectModal = true;

        break;
      }
      // 外出外泊届け
      case FunctionType.OUTING: {
        this.isLoading = true;

        // #3782
        this.errorCapture.stack = `exportReport() FunctionType.OUTING startYear:${this.startYear}, startMonth:${this.startMonth}`;

        // 外出外泊届けを期間指定で取得するために開始日、終了日を作成する
        const startDate: Moment = moment(`${this.startYear}-${this.startMonth}`, "YYYY-MM");
        const start: number = this.$dateUtil.convertDateToNumber(startDate.toDate(), "yyyymmddhhMMss000");
        const endDate: Moment = moment(`${this.endYear}-${this.endMonth}`, "YYYY-MM");
        endDate.endOf("month");
        const end: number = this.$dateUtil.convertDateToNumber(endDate.toDate(), "yyyymmdd235959000");

        const outings: Array<OutingGetModel> = await this.getOutings(start, end);
        const csv: string = this.createOutingCsv(outings, this.residentGroupMap);
        const fileName: string = this.createCsvFileName(functionType, this.residentGroupMap, this.residentMap, this.familyMap);
        this.downloadCsv(csv, fileName);

        this.isLoading = false;

        break;
      }
      default: {
        break;
      }
    }

    return;
  }

  /**
   * ### 面会予約のCSVを作成する
   *
   * - 1行目の先頭はexcel等での文字化け対策でBOMを付与する
   * - 1行目は項目名としてプレビューの表の列名を使用する
   * - 2行目以降はプレビューの表の行情報にあたる情報を作成して出力する
   * - 入力している利用者グループでフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は面会予約情報の利用者グループIDが一致するもののみ行情報の対象とする
   * - 入力している利用者でフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は面会予約情報の利用者IDが一致するもののみ行情報の対象とする
   * - 入力している家族でフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は面会予約情報の家族IDが一致するもののみ行情報の対象とする
   * - 当日以降のものは対象外
   *   - 出力境界日は「当日の0時0分0秒」
   *   - 出力境界日以降のものは出力対象外
   */
  public createReservationCsv(reservations: Array<ReservationsGetModel>, residentGroupMap: Map<number, ResidentGroupsGetModel>): string {
    let csv: string = "\ufeff" + "種別,入力,状態,面会日時,面会場所,利用者グループ,利用者名（部屋名）,面会者名（続柄）,家族からの連絡事項\n";

    for (const reservation of reservations) {
      // 利用者グループによるフィルタリング
      if (this.residentGroupId != 0 && this.residentGroupId != reservation.groupId) {
        continue;
      }
      // 利用者によるフィルタリング
      if (this.residentId != 0 && this.residentId != reservation.residentId) {
        continue;
      }
      // 家族によるフィルタリング
      if (this.residentsSortKey != "0" && this.residentsSortKey != `${reservation.residentId}-${reservation.familyId}`) {
        continue;
      }

      // #3782
      this.errorCapture.stack = `createReservationCsv() reservations:${JSON.stringify(reservations)} reservation:${JSON.stringify(reservation)}, datetime:${reservation.datetime}`;

      const line: string[] = [];
      line.push(reservation.type == ReservationType.VISIT ? "訪問" : "オンライン");
      line.push(reservation.inputType == InputType.FACILITY_APP ? "代理" : "本人");
      line.push(reservation.consented == true ? "承諾済" : "未承諾");
      const date: string = this.$dateUtil.convertNumberToString(Number(reservation.datetime), "yyyy年mm月dd日");
      const dateObject: Date = this.$dateUtil.convertNumberToDate(Number(reservation.datetime));
      const week: string = this.$dateUtil.getWeekName(dateObject, "ja");
      const time: string = this.$dateUtil.convertNumberToString(Number(reservation.datetime), "hh:MM");
      line.push(`${date}（${week}）${time}`);
      line.push(reservation.location ? reservation.location : "");
      const residentGroup: ResidentGroupsGetModel | undefined = residentGroupMap.get(reservation.groupId);
      line.push(residentGroup ? residentGroup.name : "不明");
      line.push(`${reservation.residentName}（${reservation.residentRoom}）`);
      line.push(`${reservation.familyName}（${reservation.familyRelation}）`);
      line.push(`${reservation.text ? reservation.text : ""}`);

      csv += line.join(",") + "\n";
    }

    return csv;
  }

  /**
   * ### 外出外泊届けのCSVを作成する
   *
   * - 1行目の先頭はexcel等での文字化け対策でBOMを付与する
   * - 1行目は項目名としてプレビューの表の列名を使用する
   * - 2行目以降はプレビューの表の行情報にあたる情報を作成して出力する
   * - 入力している利用者グループでフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は面会予約情報の利用者グループIDが一致するもののみ行情報の対象とする
   * - 入力している利用者でフィルタリングする
   *   - 「全て」の場合はフィルタリングしない
   *   - 「全て」以外の場合は外出外泊届け情報の利用者IDが一致するもののみ行情報の対象とする
   * - 当日以降のものは対象外
   *   - 出力境界日は「当日の0時0分0秒」
   *   - 出力境界日以降のものは出力対象外
   */
  public createOutingCsv(outings: Array<OutingGetModel>, residentGroupMap: Map<number, ResidentGroupsGetModel>): string {
    let csv: string =
      "\ufeff" +
      "種別,入力,状態,日時,利用者グループ,利用者名（部屋名）,申請者（続柄）,お迎えに来る方（続柄）,主な外出場所,外出手段,施設での食事（開始日）,施設での食事（終了日）\n";

    for (const outing of outings) {
      // 利用者グループによるフィルタリング
      if (this.residentGroupId != 0 && this.residentGroupId != outing.targetResidentInfo.groupId) {
        continue;
      }
      // 利用者によるフィルタリング
      const splitedResidentsSortKey: string[] = outing.residentsSortKey.split("_");
      if (this.residentId != 0 && this.residentId != Number(splitedResidentsSortKey[0])) {
        continue;
      }

      // #3782
      this.errorCapture.stack = `createOutingCsv() outings:${JSON.stringify(outings)} outing:${JSON.stringify(outing)}, startDatetime:${outing.startDatetime}, endDatetime:${
        outing.endDatetime
      }`;

      const line: string[] = [];
      line.push(outing.type == OutingType.GOING_OUT ? "外出" : "外泊");
      line.push(outing.inputBy == InputBy.FACILITY ? "代理" : "本人");
      line.push(outing.consented == true ? "承諾済" : "未承諾");
      line.push(this.createOutingDatetime(outing));
      const residentGroup: ResidentGroupsGetModel | undefined = residentGroupMap.get(outing.targetResidentInfo.groupId);
      line.push(residentGroup ? residentGroup.name : "不明");
      line.push(`${outing.targetResidentInfo.name}（${outing.targetResidentInfo.roomName}）`);
      line.push(`${outing.applicantFamilyInfo.name}（${outing.applicantFamilyInfo.relation}）`);
      line.push(!outing.applicantPickup && outing.pickupPerson ? `${outing.pickupPerson.name}（${outing.pickupPerson.relation}）` : "申請者本人");
      line.push(outing.location);
      line.push(outing.selectedVehicle ? outing.selectedVehicle : "");
      line.push(this.createNeedsMeal(outing.startDateNeedsMeal));
      line.push(outing.endDateNeedsMeal ? this.createNeedsMeal(outing.endDateNeedsMeal) : "");

      csv += line.join(",") + "\n";
    }

    return csv;
  }

  createOutingDatetime(outing: OutingGetModel): string {
    // 外出
    if (outing.type == OutingType.GOING_OUT) {
      const date = this.$dateUtil.convertNumberToString(outing.startDatetime, "yyyy年mm月dd日");
      const dateObject: Date = this.$dateUtil.convertNumberToDate(outing.startDatetime);
      const week = this.$dateUtil.getWeekName(dateObject, "ja");
      const startTime = this.$dateUtil.convertNumberToString(outing.startDatetime, "hh:MM");
      const endTime = this.$dateUtil.convertNumberToString(outing.endDatetime, "hh:MM");

      return `${date}（${week}）${startTime}～${endTime}`;
    }
    // 外泊
    else {
      const startDate = this.$dateUtil.convertNumberToString(outing.startDatetime, "yyyy年mm月dd日");
      const startDateObject: Date = this.$dateUtil.convertNumberToDate(outing.startDatetime);
      const startWeek = this.$dateUtil.getWeekName(startDateObject, "ja");
      const startTime = this.$dateUtil.convertNumberToString(outing.startDatetime, "hh:MM");

      const endDate = this.$dateUtil.convertNumberToString(outing.endDatetime, "yyyy年mm月dd日");
      const endDateObject: Date = this.$dateUtil.convertNumberToDate(outing.endDatetime);
      const endWeek = this.$dateUtil.getWeekName(endDateObject, "ja");
      const endTime = this.$dateUtil.convertNumberToString(outing.endDatetime, "hh:MM");

      return `${startDate}（${startWeek}）${startTime}～${endDate}（${endWeek}）${endTime}`;
    }
  }

  /**
   * ### CSVのファイル名を作成する
   *
   * - 機能別にファイル名を作成する
   */
  public createCsvFileName(
    functionType: FunctionType,
    residentGroupMap: Map<number, ResidentGroupsGetModel>,
    residentMap: Map<number, ResidentGetModel>,
    familyMap: Map<string, FamilyGetModel>
  ): string {
    let fileName: string = "";

    let suffix: string = "";
    if (this.residentGroupId != 0) {
      const residentGroup: ResidentGroupsGetModel | undefined = residentGroupMap.get(this.residentGroupId);
      const residentGroupName: string = residentGroup ? residentGroup.name : "不明";
      suffix = `-${residentGroupName}`;
    }
    if (this.residentId != 0) {
      const resident: ResidentGetModel | undefined = residentMap.get(this.residentId);
      const residentName: string = resident ? resident.name : "不明";
      const residentRoom: string = resident ? resident.room : "不明";
      suffix += `-${residentName}（${residentRoom}）`;
    }
    if (this.residentsSortKey != "0") {
      const family: FamilyGetModel | undefined = familyMap.get(this.residentsSortKey);
      const familyName: string = family ? family.familyName : "不明";
      const familyRelation: string = family ? family.familyRelation : "不明";
      suffix += `-${familyName}（${familyRelation}）`;
    }

    const monthString: string = ("0" + this.startMonth).slice(-2);
    const term: string = `-${this.startYear}${monthString}`;

    switch (functionType) {
      case FunctionType.RESERVATION: {
        fileName = `HitomeQコネクト-面会履歴${term}${suffix}.csv`;
        break;
      }
      case FunctionType.OUTING: {
        fileName = `HitomeQコネクト-外出外泊届け履歴${term}${suffix}.csv`;
        break;
      }
      default: {
        break;
      }
    }

    return fileName;
  }

  /**
   * ### CSVファイルをダウンロードさせる
   *
   * - CSVの内容からblobファイルを作成する
   * - blobファイルの種別はtext/csv
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public downloadCsv(csv: string, fileName: string): void {
    const blob: Blob = new Blob([csv], { type: "text/csv" });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    return;
  }

  /**
   * ### PDF出力形式選択後のハンドラー
   */
  async handlePdfSelectSubmit(outputType: "list" | "detail"): Promise<void> {
    if (outputType === "list") {
      await this.createAndDownloadPdf();
    } else if (outputType === "detail") {
      await this.createAndDownloadDetailPdf();
    }
    return;
  }

  /**
   * ### PDFを作成する（一覧表のみ）
   */
  public async createAndDownloadPdf(): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "PDFを作成中...";
    try {
      const fileName: string = this.createSendDocumentsPdfFileName();
      const font: string = await fontsStore.getPdfFont({ userStore });
      const sendDocumentsReportPdfUtil: SendDocumentsReportPdfUtil = new SendDocumentsReportPdfUtil(font);
      await sendDocumentsReportPdfUtil.createAndDownloadPdf(this.sendDocumentTableItems, this.facility.name, fileName);
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isLoading = false;
    }
    return;
  }

  /**
   * ### PDFを作成する（一覧表＋添付文書の1ページ目画像）
   */
  public async createAndDownloadDetailPdf(): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "PDFを作成中...";
    try {
      const fileName: string = this.createSendDocumentsPdfFileName();
      const font: string = await fontsStore.getPdfFont({ userStore });
      const imagesMap = await this.loadAllReportDetailImages();
      const sendDocumentsReportPdfUtil: SendDocumentsReportPdfUtil = new SendDocumentsReportPdfUtil(font);
      sendDocumentsReportPdfUtil.createAndDownloadDetailPdf(this.sendDocumentTableItems, this.facility.name, fileName, imagesMap);
    } catch (error) {
      errorHandle(error, this);
    } finally {
      this.isLoading = false;
    }
    return;
  }

  /**
   * ### 詳細形式用の添付書類画像を取得する
   */
  private async loadAllReportDetailImages(): Promise<Map<string, Array<string>>> {
    const imagesMap = new Map<string, Array<string>>();
    if (!this.rawSendDocuments || this.rawSendDocuments.length === 0) {
      return imagesMap;
    }

    const sendDocumentMap = new Map<number, SendDocumentGetModel>();
    for (const doc of this.rawSendDocuments) {
      sendDocumentMap.set(doc.mainId, doc);
    }

    for (let index = 0; index < this.sendDocumentTableItems.length; index++) {
      const item = this.sendDocumentTableItems[index];
      const sendDocument = sendDocumentMap.get(item.parentSendDocumentsMainId);
      if (!sendDocument || !sendDocument.fileUrls || sendDocument.fileUrls.length === 0) {
        continue;
      }

      const docFiles: Array<SendDocumentFile> = this.getSendDocumentReportFilesForItem(sendDocument, item);
      const dataUrls: Array<string> = [];
      for (const docFile of docFiles) {
        try {
          const file: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, docFile.url, docFile.name);
          if (file.type === "application/pdf") {
            const result = await PdfUtil.convertFileToJpeg(file, 1);
            if (result && result.dataUrl) {
              const portraitUrl = await PdfUtil.ensurePortraitDataUrl(result.dataUrl);
              dataUrls.push(portraitUrl);
            }
          } else if (file.type.startsWith("image/")) {
            const dataUrl = await PdfUtil.convertDataUrl(file);
            if (dataUrl) {
              const portraitUrl = await PdfUtil.ensurePortraitDataUrl(dataUrl);
              dataUrls.push(portraitUrl);
            }
          }
        } catch (e) {
          console.error(`Failed to load file: ${docFile.name}`, e);
          const systemError = e as any;
          if (systemError && (systemError.statusCode === 401 || systemError.statusCode === 403)) {
            throw e;
          }
        }
      }
      if (dataUrls.length > 0) {
        const itemKey = `${item.parentSendDocumentsMainId}_${item.sortKeyPartOne}_${item.sortKeyPartTwo}`;
        imagesMap.set(itemKey, dataUrls);
        imagesMap.set(String(index), dataUrls);
      }
    }
    return imagesMap;
  }

  /**
   * ### レポートの各項目に対応する添付ファイル一覧を取得する
   */
  private getSendDocumentReportFilesForItem(sendDocument: SendDocumentGetModel, item: SendDocumentsReportPreviewTableItem): Array<SendDocumentFile> {
    if (!sendDocument.fileUrls || sendDocument.fileUrls.length === 0) {
      return [];
    }
    if (sendDocument.unit === Unit.SAME || sendDocument.fileUrls.length === 1) {
      return sendDocument.fileUrls[0].files || [];
    }
    const sortKey = `${item.sortKeyPartOne}_${item.sortKeyPartTwo}`;
    const residentInfo = item.residentInfo as any;
    const residentIdStr = residentInfo ? String(residentInfo.id) : "";
    const matched = sendDocument.fileUrls.find((fUrl) => fUrl.sortKey === sortKey || fUrl.sortKey === residentIdStr);
    if (matched && matched.files) {
      return matched.files;
    }
    return sendDocument.fileUrls[0] ? sendDocument.fileUrls[0].files || [] : [];
  }

  /**
   * ### 文書送付履歴PDFファイル名を作成する
   */
  public createSendDocumentsPdfFileName(): string {
    const monthString: string = ("0" + this.startMonth).slice(-2);
    const term: string = `${this.startYear}${monthString}`;

    return `HitomeQコネクト-文書送付一覧-${term}.pdf`;
  }

  /**
   * ### PDFファイルをダウンロードさせる
   */
  public async downloadPdf(blob: Blob, fileName: string): Promise<void> {
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    return;
  }

  /**
   * ### 利用者選択（複数選択）の「全て選択」チェック変更イベント
   */
  public changeAllChecked(): void {
    if (this.allChecked) {
      const options = this._allResidentOptions;
      const addTargetResidentIds = [];
      for (const option of options) {
        addTargetResidentIds.push(option.value);
      }
      this.residentIds = addTargetResidentIds as any;
    } else {
      const options = this._allResidentOptions;
      const deleteTargetResidentIds: number[] = [];
      for (const option of options) {
        deleteTargetResidentIds.push(option.value as number);
      }
      const residentIds = this.residentIds.filter((id) => !deleteTargetResidentIds.includes(id));
      this.residentIds = residentIds;
    }
  }
}

/**
 * ### 機能種別
 */
enum FunctionType {
  /** 面会予約 */
  RESERVATION = 1,
  /** 文書送付 */
  SEND_DOCUMENT = 2,
  /** 外出外泊届け */
  OUTING = 3
}

enum ExistReply {
  /** 全て */
  ALL = 0,
  /** 有りのみ */
  EXIST_ONLY = 1,
  /** 無しのみ */
  NOTEXIST_ONLY = 2
}

enum SendDocumentsReportPdfType {
  UNKNOWN = -1,
  /** 全て */
  ALL = 0,
  /** 同意 */
  AGREEMENT = 1,
  /** 確認 */
  CONFIRM = 2,
  /** 無し */
  NONE = 3
}
</script>

<style lang="scss" scoped>
.export-reports-tab {
  position: relative;

  .note {
    margin: 0 0 8px 0;
  }

  .preview-table-content {
    width: 98%;
    margin: 0 20px;
  }

  .box-footer {
    padding: 10px 0 0 0 !important;
  }

  .preview-btn,
  .export-btn {
    width: 132px;
  }
}
</style>
